export default "__VITE_ASSET__DTJR$s6p__"